import type { FieldOption } from '../types';

export const eanOptions: FieldOption[] = [
  { value: '7891000100103', label: '7891000100103 — Leite Ninho Integral 400g' },
  { value: '7891000315903', label: '7891000315903 — Nescau 2.0 400g' },
  { value: '7891000055007', label: '7891000055007 — Nescafé Tradição 200g' },
  { value: '7891000248904', label: '7891000248904 — Maggi Tempero Completo 300g' },
  { value: '7891000400302', label: '7891000400302 — KitKat 45g' },
  { value: '7891000067000', label: '7891000067000 — Nescafé Gold 100g' },
  { value: '7891000315804', label: '7891000315804 — Nescau Original 370g' },
  { value: '7891150021914', label: '7891150021914 — Omo Multiação 1kg' },
  { value: '7891150012210', label: '7891150012210 — Comfort Lavanda 500ml' },
  { value: '7891150063609', label: '7891150063609 — Rexona Clinical 58g' },
  { value: '7891150017918', label: '7891150017918 — Dove Sabonete 90g' },
  { value: '7891150048903', label: '7891150048903 — Clear Anticaspa 200ml' },
  { value: '7891150065009', label: '7891150065009 — TRESemmé Shampoo 400ml' },
  { value: '7506339348001', label: '7506339348001 — Hellmann\'s Maionese 500g' },
  { value: '7891150030008', label: '7891150030008 — AXE Body Spray 150ml' },
  { value: '7898024111106', label: '7898024111106 — Pantene Shampoo 400ml' },
  { value: '7898024111304', label: '7898024111304 — Head & Shoulders 400ml' },
  { value: '7898024115203', label: '7898024115203 — Ariel 1kg' },
  { value: '7898024112103', label: '7898024112103 — Downy 500ml' },
  { value: '7898024110208', label: '7898024110208 — Gillette Prestobarba 2un' },
];

export const skuOptions: FieldOption[] = [
  { value: 'SKU-NES-001', label: 'SKU-NES-001 — Ninho Integral 400g (caixa 12un)' },
  { value: 'SKU-NES-002', label: 'SKU-NES-002 — Nescau 400g (display 6un)' },
  { value: 'SKU-NES-003', label: 'SKU-NES-003 — Nescafé Tradição 200g (cx 12un)' },
  { value: 'SKU-MAG-001', label: 'SKU-MAG-001 — Maggi Tempero 300g (cx 24un)' },
  { value: 'SKU-KIT-001', label: 'SKU-KIT-001 — KitKat 45g (fardo 24un)' },
  { value: 'SKU-OMO-001', label: 'SKU-OMO-001 — Omo Multiação 1kg (cx 12un)' },
  { value: 'SKU-COM-001', label: 'SKU-COM-001 — Comfort Lavanda 500ml (cx 12un)' },
  { value: 'SKU-REX-001', label: 'SKU-REX-001 — Rexona Clinical 58g (cx 12un)' },
  { value: 'SKU-DOV-001', label: 'SKU-DOV-001 — Dove Sabonete 90g (fardo 72un)' },
  { value: 'SKU-CLE-001', label: 'SKU-CLE-001 — Clear Anticaspa 200ml (cx 12un)' },
  { value: 'SKU-TRE-001', label: 'SKU-TRE-001 — TRESemmé Shampoo 400ml (cx 12un)' },
  { value: 'SKU-HEL-001', label: 'SKU-HEL-001 — Hellmann\'s Maionese 500g (cx 12un)' },
  { value: 'SKU-AXE-001', label: 'SKU-AXE-001 — AXE Body Spray 150ml (cx 6un)' },
  { value: 'SKU-PAN-001', label: 'SKU-PAN-001 — Pantene Shampoo 400ml (cx 12un)' },
  { value: 'SKU-ARI-001', label: 'SKU-ARI-001 — Ariel 1kg (cx 9un)' },
  { value: 'SKU-DOW-001', label: 'SKU-DOW-001 — Downy 500ml (cx 12un)' },
  { value: 'SKU-GIL-001', label: 'SKU-GIL-001 — Gillette Prestobarba 2un (cx 24un)' },
];

export const brandOptions: FieldOption[] = [
  { value: 'ninho', label: 'Ninho' },
  { value: 'nescau', label: 'Nescau' },
  { value: 'nescafe', label: 'Nescafé' },
  { value: 'maggi', label: 'Maggi' },
  { value: 'kitkat', label: 'KitKat' },
  { value: 'omo', label: 'Omo' },
  { value: 'comfort', label: 'Comfort' },
  { value: 'rexona', label: 'Rexona' },
  { value: 'dove', label: 'Dove' },
  { value: 'clear', label: 'Clear' },
  { value: 'tresemme', label: 'TRESemmé' },
  { value: 'hellmanns', label: "Hellmann's" },
  { value: 'axe', label: 'AXE' },
  { value: 'pantene', label: 'Pantene' },
  { value: 'head_shoulders', label: 'Head & Shoulders' },
  { value: 'ariel', label: 'Ariel' },
  { value: 'downy', label: 'Downy' },
  { value: 'gillette', label: 'Gillette' },
  { value: 'lux', label: 'Lux' },
  { value: 'sunsilk', label: 'Sunsilk' },
  { value: 'seda', label: 'Seda' },
  { value: 'lifebuoy', label: 'Lifebuoy' },
];

export const categoryOptions: FieldOption[] = [
  { value: 'higiene_pessoal', label: 'Higiene Pessoal' },
  { value: 'alimentos', label: 'Alimentos' },
  { value: 'bebidas', label: 'Bebidas' },
  { value: 'limpeza', label: 'Limpeza' },
  { value: 'cuidados_cabelo', label: 'Cuidados com o Cabelo' },
  { value: 'cuidados_pele', label: 'Cuidados com a Pele' },
  { value: 'desodorantes', label: 'Desodorantes' },
  { value: 'condimentos', label: 'Condimentos e Temperos' },
  { value: 'laticínios', label: 'Laticínios' },
  { value: 'chocolates', label: 'Chocolates e Doces' },
  { value: 'cafe_cha', label: 'Café e Chá' },
  { value: 'lavar_roupas', label: 'Lavar Roupas' },
  { value: 'amaciantes', label: 'Amaciantes' },
  { value: 'masculino', label: 'Cuidado Masculino' },
];

export const subcategoryOptions: FieldOption[] = [
  { value: 'shampoo', label: 'Shampoo' },
  { value: 'condicionador', label: 'Condicionador' },
  { value: 'sabonete_liquido', label: 'Sabonete Líquido' },
  { value: 'sabonete_barra', label: 'Sabonete em Barra' },
  { value: 'creme_hidratante', label: 'Creme Hidratante' },
  { value: 'desodorante_aerossol', label: 'Desodorante Aerossol' },
  { value: 'desodorante_roll_on', label: 'Desodorante Roll-On' },
  { value: 'desodorante_stick', label: 'Desodorante Stick' },
  { value: 'leite_em_po', label: 'Leite em Pó' },
  { value: 'achocolatado', label: 'Achocolatado' },
  { value: 'cafe_soluvel', label: 'Café Solúvel' },
  { value: 'temperos', label: 'Temperos e Realçadores' },
  { value: 'maionese', label: 'Maionese' },
  { value: 'detergente', label: 'Detergente' },
  { value: 'lava_roupas_po', label: 'Lava Roupas em Pó' },
  { value: 'lava_roupas_liquido', label: 'Lava Roupas Líquido' },
  { value: 'barbeadores', label: 'Barbeadores' },
  { value: 'espuma_barbear', label: 'Espuma de Barbear' },
];

export const departmentOptions: FieldOption[] = [
  { value: 'higiene_beleza', label: 'Higiene e Beleza' },
  { value: 'mercearia', label: 'Mercearia' },
  { value: 'limpeza_casa', label: 'Limpeza da Casa' },
  { value: 'frios_laticinios', label: 'Frios e Laticínios' },
  { value: 'bebidas_quentes', label: 'Bebidas Quentes' },
  { value: 'bebidas_frias', label: 'Bebidas Frias' },
  { value: 'confeitaria', label: 'Confeitaria' },
  { value: 'perfumaria', label: 'Perfumaria' },
  { value: 'infantil', label: 'Infantil' },
];

export const industryOptions: FieldOption[] = [
  { value: 'unilever', label: 'Unilever' },
  { value: 'nestle', label: 'Nestlé' },
  { value: 'pg', label: 'P&G (Procter & Gamble)' },
  { value: 'loreal', label: "L'Oréal" },
  { value: 'johnson', label: 'Johnson & Johnson' },
  { value: 'colgate', label: 'Colgate-Palmolive' },
  { value: 'reckitt', label: 'Reckitt' },
  { value: 'henkel', label: 'Henkel' },
  { value: 'sc_johnson', label: 'SC Johnson' },
  { value: 'kraft_heinz', label: 'Kraft Heinz' },
  { value: 'ambev', label: 'Ambev' },
  { value: 'pepsico', label: 'PepsiCo' },
  { value: 'coca_cola', label: 'Coca-Cola' },
  { value: 'mars', label: 'Mars' },
  { value: 'multiindustria', label: 'Multi (vários)' },
];

export const familyOptions: FieldOption[] = [
  { value: 'familia_laticinio', label: 'Família Laticínios Nestlé' },
  { value: 'familia_chocolate', label: 'Família Chocolates' },
  { value: 'familia_cafe', label: 'Família Cafés Nestlé' },
  { value: 'familia_condimentos', label: 'Família Condimentos Unilever' },
  { value: 'familia_higiene_unilever', label: 'Família Higiene Unilever' },
  { value: 'familia_limpeza_unilever', label: 'Família Limpeza Unilever' },
  { value: 'familia_cuidado_cabelo', label: 'Família Cuidado Cabelo P&G' },
  { value: 'familia_masculino_pg', label: 'Família Masculino P&G' },
  { value: 'familia_higiene_colgate', label: 'Família Higiene Colgate' },
  { value: 'familia_limpeza_reckitt', label: 'Família Limpeza Reckitt' },
  { value: 'familia_bebidas_ambev', label: 'Família Bebidas Ambev' },
  { value: 'familia_snacks_pepsico', label: 'Família Snacks PepsiCo' },
];

export const sellerOptions: FieldOption[] = [
  { value: 'carrefour', label: 'Carrefour' },
  { value: 'extra', label: 'Extra' },
  { value: 'atacadao', label: 'Atacadão' },
  { value: 'sam_club', label: "Sam's Club" },
  { value: 'pao_acucar', label: 'Pão de Açúcar' },
  { value: 'assai', label: 'Assaí Atacadista' },
  { value: 'makro', label: 'Makro' },
  { value: 'coop', label: 'Coop' },
  { value: 'condor', label: 'Condor' },
  { value: 'bistek', label: 'Bistek' },
  { value: 'zona_sul', label: 'Zona Sul' },
  { value: 'prezunic', label: 'Prezunic' },
  { value: 'oba', label: 'OBA Hortifruti' },
  { value: 'verdemar', label: 'Verdemar' },
  { value: 'hirota', label: 'Hirota Food Supermercado' },
];

export const cnpjOptions: FieldOption[] = [
  { value: '45543915000154', label: '45.543.915/0001-54 — Carrefour Comércio e Indústria Ltda' },
  { value: '47508411000156', label: '47.508.411/0001-56 — Sendas Distribuidora S.A. (Extra/Assaí)' },
  { value: '89671480000108', label: '89.671.480/0001-08 — Irmãos Bretas Filhos e Cia Ltda' },
  { value: '75315333000109', label: '75.315.333/0001-09 — Wal-Mart Brasil Ltda (Sam\'s Club)' },
  { value: '47960950000121', label: '47.960.950/0001-21 — Companhia Brasileira de Distribuição (GPA)' },
  { value: '60396634000101', label: '60.396.634/0001-01 — Makro Atacadista S.A.' },
  { value: '76430381000154', label: '76.430.381/0001-54 — Coop - Cooperativa de Consumo' },
  { value: '76557839000170', label: '76.557.839/0001-70 — Condor Super Center Ltda' },
  { value: '87456575000115', label: '87.456.575/0001-15 — Bistek Supermercados Ltda' },
  { value: '34028316000103', label: '34.028.316/0001-03 — Zona Sul Comércio Varejista Ltda' },
  { value: '17312661000185', label: '17.312.661/0001-85 — Prezunic Comercial Ltda' },
  { value: '06627255000107', label: '06.627.255/0001-07 — OBA Hortifruti Ltda' },
  { value: '19895029000160', label: '19.895.029/0001-60 — Verdemar Supermercados Ltda' },
  { value: '60830248000103', label: '60.830.248/0001-03 — Hirota Food Supermercado Ltda' },
  { value: '10565252000104', label: '10.565.252/0001-04 — Distribuidora Kennedy Ltda' },
];
